import React, { useState, useEffect } from 'react';
import LeftBar from '../../Pages/Layout/LeftBar';
import TopBar from '../../Pages/Layout/TopBar';
import Footer from '../../Pages/Layout/Footer';
import { CalendarEvent } from '../../Helper/HomeHelper';

const colorMap = {
  Layout: 'success',
  Campaign: 'primary',
  Media: 'info',
  Schedule: 'warning'
};

const CalendarReport = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchEvents();
  }, [currentDate]);

  const fetchEvents = async () => {
    const id = localStorage.getItem("userId");
    const data = await CalendarEvent(id);
    if (data) {
      setEvents(Array.isArray(data.items) ? data.items : data);
    }
  };

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const getCalendarData = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const lastDate = new Date(year, month + 1, 0).getDate();

    const weeks = [];
    let day = 1 - firstDay;

    while (day <= lastDate) {
      const week = [];
      for (let i = 0; i < 7; i++) {
        week.push(day > 0 && day <= lastDate ? day : '');
        day++;
      }
      weeks.push(week);
    }

    return weeks;
  };

  const weeks = getCalendarData(currentDate);
  const monthName = currentDate.toLocaleString('default', { month: 'long' });
  const year = currentDate.getFullYear();

  const handlePrev = () => setCurrentDate(new Date(year, currentDate.getMonth() - 1, 1));
  const handleNext = () => setCurrentDate(new Date(year, currentDate.getMonth() + 1, 1));

  return (
    <>
      <TopBar />
      <LeftBar />

      <div className="container-fluid content-top-gap">
        {/* Breadcrumb */}
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb my-breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Calendar</li>
          </ol>
        </nav>

        {/* Page Header */}
        <div className="welcome-msg pt-3 pb-4">
          <h2>📅 Calendar</h2>
          <p>Manage Layout, Campaign, Media, and Schedule events visually.</p>
        </div>

        {/* Calendar Table */}
        <div className="card mb-5">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">{monthName} {year}</h5>
            <div>
              <button className="btn btn-sm btn-outline-primary mr-2" onClick={handlePrev}>Previous</button>
              <button className="btn btn-sm btn-outline-primary" onClick={handleNext}>Next</button>
            </div>
          </div>

          <div className="card-body table-responsive">
            <table className="table table-bordered text-center mb-0">
              <thead className="thead-light">
                <tr>
                  {days.map((day, i) => <th key={i}>{day}</th>)}
                </tr>
              </thead>
              <tbody>
                {weeks.map((week, wIdx) => (
                  <tr key={wIdx}>
                    {week.map((date, dIdx) => {
                      const cellDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), date);
                      const cellEvents = events?.filter(ev => {
                        const evDate = new Date(ev.date);
                        return evDate.getFullYear() === cellDate.getFullYear()
                          && evDate.getMonth() === cellDate.getMonth()
                          && evDate.getDate() === cellDate.getDate();
                      }) || [];

                      return (
                        <td key={dIdx} style={{ height: '100px', verticalAlign: 'top' }}>
                          {date && <div><strong>{date}</strong></div>}
                          {cellEvents.map((ev, i) => (
                            <div key={i} className={`badge badge-${colorMap[ev.type] || 'secondary'} mt-1`}>
                              {ev.type}: {ev.title || '-'}
                            </div>
                          ))}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default CalendarReport;
